// API service for payment form management
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class PaymentFormService {
  static async getAllPaymentForms(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/payment-forms`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching all payment forms:', error);
      throw error;
    }
  }

  static async getPaymentForms(token, limit = 50, lastKey = null) {
    try {
      let url = `${API_BASE_URL}/payment-forms?limit=${limit}`;
      if (lastKey) {
        url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        paymentForms: data.data,
        pagination: data.pagination
      };
    } catch (error) {
      console.error('Error fetching payment forms:', error);
      throw error;
    }
  }

  static async getPaymentFormById(paymentFormId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/payment-forms/${paymentFormId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching payment form:', error);
      throw error;
    }
  }

  static async createPaymentForm(paymentFormData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/payment-forms`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(paymentFormData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error creating payment form:', error);
      throw error;
    }
  }

  static async updatePaymentForm(paymentFormId, paymentFormData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/payment-forms/${paymentFormId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(paymentFormData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error updating payment form:', error);
      throw error;
    }
  }

  static async deletePaymentForm(paymentFormId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/payment-forms/${paymentFormId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting payment form:', error);
      throw error;
    }
  }

  static async searchPaymentForms(query, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/payment-forms/search?query=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error searching payment forms:', error);
      throw error;
    }
  }
}

export default PaymentFormService;
